import PropertiesGrid from '../components/PropertiesGrid'
import Video from '../components/Video'
import mobile from '../assets/videos/propertiesMob.mp4'
import desktop from '../assets/videos/propertiesDesktop.mp4'
import mobilePoster from '../assets/videos/propMobPoster.avif'
import desktopPoster from '../assets/videos/propDeskPoster.avif'
import { useTranslation } from 'react-i18next'

export default function Properties() {
  const { t } = useTranslation()
  return (
    <article>
      <Video
        mobile={mobile}
        desktop={desktop}
        mobilePoster={mobilePoster}
        desktopPoster={desktopPoster}
        title={t('propertiesVideo.title')}
        subTitle={t('propertiesVideo.subTitle')}
        link={'#properties'}
      />
      <PropertiesGrid id={'properties'} />
    </article>
  )
}
